<div class="row">

  <div class="col-sm-2"></div>
  <div *ngIf="completeMessage !== ''">{{ completeMessage }}</div>
  <div *ngIf="completeMessage === ''" class="col-sm-8">
    <h1 class="text-center">Блокирование закупки</h1>
    <form [formGroup]="form" (ngSubmit)="submit()">

      <div class="form-group row">

        <div class="col-sm-4">
          <label for="block__description">Причина блокировки <span class="text-danger">*</span></label>
        </div>

        <div class="col-sm-8">
          <textarea formControlName="description" name="description" id="block__description" cols="30" rows="10" style="width: 100%"></textarea>
          <p class="text-danger" *ngIf="form.get('description').invalid && form.get('description').touched">Поле обязательно для заполнения</p>
        </div>
      </div>

      <div class="form-group row">

        <div class="col-sm-4">
          <label for="block__type">Действие <span class="text-danger">*</span></label>
        </div>

        <div class="col-sm-8" id="block__type">
          <div class="row">
            <div class="col-sm-1">
              <input type="radio" id="block__typeFull"
                     name="type" formControlName="type" value="full">
            </div>
            <div class="col-sm-11">
              <label for="block__typeFull">заблокировать закупку</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-1">
              <input type="radio" id="block__typeContract"
                     name="type" formControlName="type" value="contract">
            </div>
            <div class="col-sm-11">
              <label for="block__typeFull">заблокировать возможность заключения контракта</label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-3"></div>
        <div class="col-sm-9">
          <button type="submit" class="btn btn-primary">Подписать документ</button>
          <select formControlName="selectedCert" name="selectedCert" class="form-control-sm" style="margin: 10px; width: 300px;">
            <option value=""></option>
            <option *ngFor="let cert of certsList" [value]="cert.thumbprint">{{ cert.label }}</option>
          </select>
          <p class="text-danger" *ngIf="form.get('selectedCert').invalid && form.get('selectedCert').touched"></p>
        </div>
      </div>

    </form>
  </div>
  <div class="col-sm-2"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/block/block.component.html